"use strict";

/**
* Класс для числовых реквизитов.
* 
* @class WebAccess.components.wrappers.form.requisites._details.Integer
* @extends WebAccess.components.wrappers.form.requisites.Integer
* @mixes WebAccess.components.wrappers.form.requisites._details.editModeMixin
* @private
* @since 5.0.0.7100
*/
(function (global) {

  var Integer = global.Integer.extend([global._details.editModeMixin], {
    className: "DetailInteger"
  });

  global._details.Integer = Integer;
})(window.WA.CMP.wrappers.form.requisites);


